
import axios from "axios";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { DataItemProps } from ".";

interface ApiDataAggregateInputProps {
    formCode: string;
    q?: string;
    statusIds?: number[];
    hasIds?: number[];
    [key: string]: any
}

type ApiDataAggregateOutputProps = OutputBaseProps<{ item: Record<string, { average: number; sum: number; count: number }> }>

export const apiDataAggregate = async ({ formCode, ...data }: ApiDataAggregateInputProps) => {
    const res = (await axios.get<ApiDataAggregateOutputProps>(`/api/data/${formCode}/aggregate`, { params: data }))
        .data;
    return res;
};

interface ApiDataIdInputProps extends Omit<ApiDataAggregateInputProps, "formCode"> {
    formId: number;
}
export const apiDataIdAggregate = async ({ formId, ...data }: ApiDataIdInputProps, locale?: string) => {
    const res = (await axios.get<ApiDataAggregateOutputProps>(`/api/data/id/${formId}/aggregate`, { params: data, headers: locale ? { locale } : {} }))
        .data;
    return res;
};